import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

const portfolioItems = [
  {
    image: 'assets/images/v2vimages/SliderEvent-1.jpg',
    title: 'Event One',
    designation: 'Ahemdabad  ',
  },
  {
    image: 'assets/images/v2vimages/SliderEvent-2.jpg',
    title: 'Event Two',
    designation: 'Ahemdabad  ',
  },
  {
    image: 'assets/images/v2vimages/SliderEvent-3.jpg',
    title: 'Event Three',
    designation: 'Ahemdabad  ',
  },
  {
    image: 'assets/images/v2vimages/SliderEvent-4.jpg',
    title: 'Event Four',
    designation: 'Ahemdabad  ',
  },
  {
    image: 'assets/images/v2vimages/SliderEvent-5.jpg',
    title: 'Events Five ',
    designation: 'Ahemdabad  ',
  },
  {
    image: 'assets/images/v2vimages/SliderEvent-6.png',
    title: 'Event Six',
    designation: 'Ahemdabad  ',
  },
  {
    image: 'assets/images/v2vimages/SliderEvent-7.jpg',
    title: 'Events Seven ',
    designation: 'Ahemdabad  ',
  },
  
 
];

function Portfolio() {
  return (
    <div>
      <div className="tmp-product-area tmp-section-gapTop bg-product-1">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head color-white">
                <div className="section-sub-title center-title">
                  <img
                    src="assets/images/services/section-custom-menubar.png"
                    alt="Corporate_service"
                  />
                  <span className="subtitle">OUR events</span>
                </div>
                <h2 className="title split-collab text-white">Building Bridges Through Events </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container-full">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-swiper-area-one">
                <Swiper
                  modules={[Navigation, Pagination, EffectFade, Scrollbar, A11y, Autoplay]}
                  className="mySwiper-portfolio-1"
                  speed={500}
                  slidesPerView={5}
                  spaceBetween={30}
                  loop={true}
                  centeredSlides={true}
                  autoplay={{
                    delay: 5500,
                    disableOnInteraction: false,
                  }}
                  navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  }}
                  breakpoints={{
                    1200: { slidesPerView: 5 },
                    900: { slidesPerView: 3 },
                    768: { slidesPerView: 3 },
                    580: { slidesPerView: 2 },
                    450: { slidesPerView: 1 },
                    0: { slidesPerView: 1 },
                  }}
                >
                  {portfolioItems.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="signle-product-start"
                        data-tmp-cursor="lg text-secondary transparent fw-bold"
                        data-tmp-cursor-icon="fa-solid fa-arrow-up-right"
                        style={{borderRadius:'10px'}}
                      >
                        <img src={item.image} alt={item.title} style={{borderRadius:'10px'}}/>
                        <div className="inner-content">
                          <h5 className="title" style={{ fontSize: '18px' }}>{item.title}</h5>
                          <span className="designation">{item.designation}</span>
                          <div className="tag" />
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}

                  <div className="swiper-button-next"></div>
                  <div className="swiper-button-prev"></div>
                  <div className="swiper-pagination"></div>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
